import { useEffect } from 'react';
import type { FC } from 'react';

import type { OnCurrentContentBodyDynamicChange } from './CurrentContentBodyDynamicTracker.tsx';

type Props = {
	contentId: string;
	onCurrentContentBodyDynamicChange?: OnCurrentContentBodyDynamicChange;
};

export const CurrentContentBodyDynamicUnavailableTracker: FC<Props> = ({
	contentId,
	onCurrentContentBodyDynamicChange,
}) => {
	useEffect(() => {
		onCurrentContentBodyDynamicChange?.(undefined, contentId);
	}, [contentId, onCurrentContentBodyDynamicChange]);

	return null;
};
